export { SectionFooterComponent as SectionFooter } from './SectionFooter';
